import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PageTab, { PageTabModel } from 'shared/components/page-tab/page-tab';
import Routes from 'shared/enums/routes';
import { useConnectorContextProvider } from 'shared/providers/connector/context/connector-provider';

const SettingTabs = () => {
  const { t } = useTranslation('settings');
  const navigate = useNavigate();
  const { hasVcareConnector } = useConnectorContextProvider();

  const pageTabs: PageTabModel[] = [
    {
      subRoute: Routes.SettingsExplanationLink,
      title: t('pageTab.explanationLabel'),
    },
    {
      subRoute: Routes.SettingsEmergencyAlarm,
      title: t('pageTab.emergencyAlarmLabel'),
    },
    ...(hasVcareConnector
      ? [
          {
            subRoute: Routes.SettingsCareConnect,
            title: t('pageTab.careConnectLabel'),
          },
        ]
      : []),
    {
      subRoute: Routes.SettingsWanderingBoundaries,
      title: t('pageTab.wanderingBoundariesLabel'),
    },
    {
      subRoute: Routes.SettingsMalfunctionNotifications,
      title: t('pageTab.malfunctionNotificationsLabel'),
    },
    {
      subRoute: Routes.SettingsMediaserverSwitch,
      title: t('pageTab.mediaLabel'),
    },
  ];

  return <PageTab onPageChanged={(link: string) => navigate(link)} mainRoute={Routes.Settings} pageTabs={pageTabs} />;
};

export default SettingTabs;
